import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import { PermissionType } from 'types/staff'

type Props = {
  permission: PermissionType | 'time_sale' | 'release_app' | 'release_web'
  toggle: (event: ChangeEvent<HTMLInputElement>) => void
  on: boolean
}

const ToggleRoundButton: FC<Props> = (props) => {
  const { permission, toggle, on } = props
  return (
    <label className={on ? styles.toggle_round_active : styles.toggle_round} htmlFor={permission}>
      <input
        className={styles.toggle_round__input}
        checked={on}
        id={permission}
        onChange={(event: ChangeEvent<HTMLInputElement>) => toggle(event)}
        type={'checkbox'}
      />
      <span className={on ? styles.toggle_round__circle_active : styles.toggle_round__circle} />
      <span className={on ? styles.toggle_round__text_active : styles.toggle_round__text}>{on ? 'ON' : 'OFF'}</span>
    </label>
  )
}

export default ToggleRoundButton
